import React from "react";
import ClientReportHistoryModal from "./components/Dialog";
import { ReportHistoryProvider } from "./hooks/ReportHistoryContext";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";
import { ClientReportHistoryModalProps } from "./types";

export function openClientReportHistoryModal(masterAccountId: string, reportId: string) {
    return createConfirmation<ClientReportHistoryModalProps, any>(confirmable((props) => (
        <ReportHistoryProvider masterAccountId={masterAccountId} reportId={reportId}>
            <ClientReportHistoryModal {...props} />
        </ReportHistoryProvider>
    )))({
        dialogId: 'client_report_history_modal',
        masterAccountId,
        reportId
    });
}